export const classNames = {
  card: 'bg-white rounded-lg	border border-gray-200 shadow-sm',
};
